export default __webpack_public_path__ + "static/Poppins-Medium-9e1bb626874ed49aa343d66b8d66ceaf.ttf";